export const categoryDetailsController = {
  initial: 'off',
  states: {
    off: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'on',
          cond: 'isCategoryDetailsPage',
          actions: ['setBodyNonScrollable'],
        },
      },
    },
    on: {
      states: {
        layoutReloader: {
          initial: 'reloading',
          states: {
            idle: {
              on: {
                RELOAD_CATEGORIES: 'reloading',
              },
            },
            reloading: {
              invoke: {
                src: 'getCategoryDetailsLayoutContent',
                onDone: {
                  target: 'idle',
                },
              },
            },
          },
        },
      },
      on: {
        LAYOUT_CHANGE_END: {
          target: 'off',
          cond: 'isControllerDisabled_categoryDetails',
          actions: [
            'setBodyScrollable',
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.CategoryDetails.properties.games',
                value: [],
              },
            },
          ],
        },
      },
    },
  },
};
